import { render } from "./chargeGroup.vue?vue&type=template&id=28711fda&scoped=true"
import script from "./chargeGroup.vue?vue&type=script&lang=js"
export * from "./chargeGroup.vue?vue&type=script&lang=js"

import "./chargeGroup.vue?vue&type=style&index=0&id=28711fda&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28711fda"]])

export default __exports__